import { FiCheckCircle } from 'react-icons/fi'

import { t } from 'i18next'

import { Button } from '~/components/Buttons'

import * as S from './styles'

type SuccessViewProps = {
  onClose: () => void
}

const SuccessView = ({ onClose }: SuccessViewProps) => {
  return (
    <S.SuccessContainer>
      <S.IconWrapper>
        <FiCheckCircle size={64} />
      </S.IconWrapper>
      <S.SuccessTitle>
        {t('rm:externalCampaignMetrics.form.success.title')}
      </S.SuccessTitle>
      <S.SuccessMessage>
        {t('rm:externalCampaignMetrics.form.success.message')}
      </S.SuccessMessage>
      <Button
        text={t('rm:externalCampaignMetrics.form.success.ok')}
        template="primary"
        onClick={onClose}
      />
    </S.SuccessContainer>
  )
}

export default SuccessView
